<template>
  <BRow>
    <BCol
      cols="12"
    >
      <div
        class="d-flex flex-column flex-md-row justify-content-between flex-grow-1"
      >
        <div>
          <div
            v-if="products.length >= 1"
            class="d-flex"
            style="column-gap: 5px; row-gap: 5px;"
          >
            <BButton
              v-if="tableProducts.selected.details.length <= 0"
              v-b-tooltip.hover.bottomright="{ variant: 'success' }"
              title="Select All"
              size="sm"
              :variant="products.length <= 1 ? 'outline-dark' : 'outline-success'"
              class="text-nowrap"
              :disabled="products.length <= 1"
              @click.prevent="$event => selectProducts(true)"
            >
              <i class="fa-lg fad fa-list-check pr-0" />
            </BButton>
            <BButton
              v-else-if="tableProducts.selected.details.length > 0"
              v-b-tooltip.hover.bottomright="{ variant: 'warning' }"
              title="Unselect All"
              size="sm"
              variant="outline-warning"
              class="text-nowrap"
              @click.prevent="$event => selectProducts(false)"
            >
              <i class="fa-md fad fa-align-slash pr-0" />
            </BButton>
            <BButton
              v-b-tooltip.hover.bottomright="{ variant: 'danger' }"
              title="Remove All Selected"
              size="sm"
              :variant="tableProducts.selected.details.length <= 0 ? 'outline-dark' : 'outline-danger'"
              class="text-nowrap"
              :disabled="tableProducts.selected.details.length <= 0"
              @click.prevent="$event => removeProducts()"
            >
              <i class="fa-lg fad fa-trash-can pr-0" />
            </BButton>
          </div>
        </div>
        <div
          class="d-flex align-self-end pb-2 order-1 order-md-2 flex-md-row flex-column"
          style="column-gap: 5px; row-gap: 5px;"
        >
          <div>
            <BInputGroup
              size="sm"
            >
              <BFormInput
                v-model="additional"
                class="text-right min-w-75px max-w-100px"
                placeholder="0"
                type="number"
                min="1"
                max="25"
                step="1"
                size="sm"
              />
              <BInputGroupAppend>
                <BButton
                  size="sm"
                  variant="outline-dark"
                  class="min-w-45px"
                  @click.prevent="() => addProduct(additional)"
                >
                  +
                </BButton>
              </BInputGroupAppend>
            </BInputGroup>
          </div>
          <div
            class="d-flex"
            style="column-gap: 5px; row-gap: 5px;"
          >
            <BButton
              size="sm"
              variant="outline-dark"
              class="min-w-45px"
              @click.prevent="$event => addProduct(5)"
            >
              +5
            </BButton>
            <BButton
              size="sm"
              variant="outline-dark"
              class="min-w-45px"
              @click.prevent="$event => addProduct(10)"
            >
              +10
            </BButton>
          </div>
        </div>
      </div>
    </BCol>

    <BCol
      cols="12"
    >

      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BTable
          ref="tableProducts"
          small
          hover
          striped
          bordered
          responsive
          show-empty
          class="mb-0 px-0 min-h-300px"
          sticky-header="calc(100vh - 22.4rem)"
          :items="products"
          :busy="tableProducts.busy"
          :filter="tableProducts.filter"
          :fields="tableProducts.fields"
          :stacked="tableProducts.stacked"
          :filter-included-fields="tableProducts.filterOn"
          @row-contextmenu="tableRowRightClick"
        >

          <template #head(selected)>
            <BFormCheckbox
              v-model="tableProducts.selected.allSelected"
              :indeterminate="(tableProducts.selected.indeterminate)"
              :disabled="(tableProducts.busy || products.length <= 1)"
              size="lg"
              tabindex="-1"
              @change="selectProducts"
            />
          </template>

          <template #cell(index)="{ index }">
            <div
              class="text-md-nowrap d-flex justify-content-center align-items-centermin-h-35px"
              v-text="tableRowNumber(tableProducts, index)"
            />
          </template>

          <template #cell(selected)="{ index }">
            <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
              <BFormCheckbox
                v-model="tableProducts.selected.details"
                :disabled="(tableProducts.busy || products.length <= 1)"
                :value="index"
                size="lg"
                tabindex="-1"
              />
            </div>
          </template>

          <template #cell(action)="{ item, index }">
            <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
              <BButton
                :disabled="(tableProducts.busy || products.length <= 1)"
                :variant="products.length <= 1 ? 'outline-dark' : 'outline-danger'"
                class="border-0"
                tabindex="-1"
                @click.prevent="() => removeProduct(item, index, false)"
              >
                <i class="fa-lg fad fa-trash-can pr-0" />
              </BButton>
            </div>
          </template>

          <template #cell(product.category_name)="{ value }">
            <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
              <strong
                class="font-weight-bolder"
                style="font-size: 1rem;"
                v-text="value"
              />
            </div>
          </template>

          <template #cell(product_name)="{ item, index }">
            <div class="text-md-nowrap">
              <Product
                :item="item"
                :index="index"
                :options="filterProductOptions(item.product)"
                @selected="selectProduct"
              />
            </div>
          </template>

          <template #cell(quantity)="{ item, index }">
            <div class="text-md-nowrap">
              <Quantity
                :item="item"
                :index="index"
                @enter="focusOnNewProduct"
                @cleared="focusOnProductSelection"
                @moveUp="moveUpProductQuantity"
                @moveDown="moveDownProductQuantity"
              />
            </div>
          </template>

          <!-- <template #cell(action)="{ item, index }">
        <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center" />
      </template> -->

          <template #table-busy>
            <div class="text-center py-5">
              <BIcon
                icon="stopwatch"
                font-scale="5"
                animation="cylon"
              />
              <p class="h3 py-2">
                <strong>Loading . . .</strong>
              </p>
            </div>
          </template>

        </BTable>
      </form>
    </BCol>
  </BRow>
</template>
<script>
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import Product from '@/components/tables/products/Product.vue'
import Quantity from '@/components/tables/products/Quantity.vue'

export default {
  name: 'VPOTable',
  components: {
    Product,
    Quantity
  },
  mixins: [
    MISC,
    FORMATTER
  ],
  props: {
    details: {
      type: Array,
      default: () => [],
      required: true
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data () {
    return {
      additional: 1,
      products: this.details,
      selected: {
        product: '',
        products: []
      },
      tableProducts: {
        selected: {
          details: [],
          allSelected: false,
          indeterminate: false
        },
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center min-w-25px' },
          { mobile: 1, key: 'selected', class: 'text-center min-w-50px' },
          { mobile: 2, key: 'product.category_name', label: 'Category', class: { 'col-12 col-md-3': !this.isMobile() } },
          { mobile: 3, key: 'product_name', class: { 'col-12 col-md-6': !this.isMobile() } },
          { mobile: 4, key: 'quantity', class: ['text-center', { 'col-12 col-md-2': !this.isMobile() }] },
          { mobile: 5, key: 'action', class: 'text-center min-w-50px' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  watch: {

    'tableProducts.selected.details' (newValues) {
      if (newValues.length === 0) {
        this.tableProducts.selected.indeterminate = false
        this.tableProducts.selected.allSelected = false
      } else if (newValues.length === this.products.length) {
        this.tableProducts.selected.indeterminate = false
        this.tableProducts.selected.allSelected = true
      } else {
        this.tableProducts.selected.indeterminate = true
        this.tableProducts.selected.allSelected = false
      }
    }
  },

  methods: {

    tableRowRightClick (_product, _productLocation, event) {
      event.preventDefault()
    },

    filterProductOptions (sProduct) {
      const products = this.products.filter(
        ({ product }) => product?.product_code
      ).map(
        ({ product }) => product?.product_code
      )
      return this.options.filter(
        oProduct => (
          (oProduct.product_code === sProduct?.product_code) || (
            !products.includes(oProduct.product_code)
          )
        )
      )
    },

    focusOnProductQuantity (_, quantityLocation) {
      const quantity = document.getElementById(`details.${quantityLocation}.quantity`)
      if (quantity) {
        quantity.focus()
      }
    },

    moveUpProductQuantity (_, quantityLocation) {
      this.focusOnProductQuantity(_, quantityLocation - 1)
    },

    moveDownProductQuantity (_, quantityLocation) {
      this.focusOnProductQuantity(_, quantityLocation + 1)
    },

    focusOnProductSelection (_, productLocation) {
      const product = document.getElementById(`details.${productLocation}.product`)
      if (product) {
        product.focus()
      }
    },

    focusOnNewProduct (_, productLocation) {
      const nextLocation = Number(productLocation) + 1

      if (this.products.length === nextLocation) {
        this.addProduct(1)
      }

      setTimeout(() => {
        const hasNext = document.getElementById(`details.${nextLocation}.product`)
        if (hasNext) {
          hasNext.focus()
        }
      }, 300)
    },

    addProduct (count = 5) {
      if (count > 25) {
        this.additional = 25
        return null
      }

      this.products.push(
        ...Array.from({ length: Number(count) }).map(
          () => ({
            product: '',
            quantity: null
          })
        )
      )

      this.additional = 1

      // this.updated()
    },

    removeProduct (_, productLocation, useFocus = false) {
      const validatedProducts = this.products.filter(
        (_, location) => Number(productLocation) !== Number(location)
      )

      if (validatedProducts.length <= 0) {
        return this.swalInvalid('<h6>Order must have atleast 1 product</h6>', 'Removal Canceled')
      }

      if (validatedProducts.length <= 1) {
        this.tableProducts.selected.details = []
      }

      this.products = validatedProducts

      if (useFocus) {
        this.focusOnProductSelection(_, (Number(productLocation) - 1))
      }

      this.$vnode.context.$refs.formProducts.reset()
      // this.updated()

      this.$root.$emit('bv::hide::tooltip')
    },

    removeProducts () {
      const validatedProducts = this.products.filter(
        (_, location) => !this.tableProducts.selected.details.includes(location)
      )

      if (validatedProducts.length <= 0) {
        return this.swalInvalid('<h6>Order must have atleast 1 product</h6>', 'Removal Canceled')
      }

      this.products = validatedProducts

      this.tableProducts.selected.details = []

      this.$root.$emit('bv::hide::tooltip')
    },

    selectProduct (_selectedProduct, _productLocation) {
      // this.updated()
    },

    selectProducts (selectAll) {
      this.tableProducts.selected.details = selectAll ? (
        this.products.map((_, location) => location)
      ) : []
    },

    updated () {
      this.$emit('updated', this.products)
    },

    getFinalProducts () {
      return this.products.map(
        ({ product, quantity }) => ({
          id: product?.id || '',
          category_id: product?.category_id || '',
          category_code: product?.category_code || '',
          category_name: product?.category_name || '',
          group_code: product?.group_code || '',
          group_name: product?.group_name || '',
          product_code: product?.product_code || '',
          product_name: product?.product_name || '',
          quantity: quantity || null
        })
      )
    },

    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.formProducts.validate().then(
          validProducts => {
            if (validProducts) {
              resolve(validProducts)
            } else {
              reject(validProducts)
            }
          }
        )
      })
    }
  }
}
</script>
